export const CHART_COLORS = [
  '#3B82F6', // blue-500
  '#10B981', // green-500
  '#8B5CF6', // purple-500
  '#F59E0B', // orange-500
  '#EF4444', // red-500
  '#F59E0B', // yellow-500
  '#EC4899', // pink-500
  '#6366F1'  // indigo-500
]

export const getChartColor = (index: number, groupValue?: string) => {
  if (groupValue) {
    const hash = groupValue.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0)
      return a & a
    }, 0)
    return CHART_COLORS[Math.abs(hash) % CHART_COLORS.length]
  }
  return CHART_COLORS[index % CHART_COLORS.length]
}

export const getVariantColor = (variant: string) => {
  switch (variant) {
    case 'success':
      return 'text-green-600 dark:text-green-400'
    case 'warning':
      return 'text-yellow-600 dark:text-yellow-400'
    case 'info':
      return 'text-blue-600 dark:text-blue-400'
    default:
      return 'text-primary-600 dark:text-primary-400'
  }
}

export const getVariantBgColor = (variant: string) => {
  switch (variant) {
    case 'success':
      return 'bg-green-500/20'
    case 'warning':
      return 'bg-yellow-500/20'
    case 'info':
      return 'bg-blue-500/20'
    default:
      return 'bg-primary-500/20'
  }
} 